import { doc } from 'firebase/firestore';
import { ID } from 'shared/types/id';
import { UpdateSmartList } from 'shared/types/smart-list';

import { CollectionOptions, getCollection } from './helpers';
import { updateDocWithTimestamp } from './helpers/update-doc-with-timestamp';

export const updateSmartList = async (
  _uid: ID,
  smartList: UpdateSmartList,
): Promise<void> => {
  const collection = getCollection(CollectionOptions.SmartLists);
  const ref = doc(collection, smartList.id);

  await updateDocWithTimestamp(ref, smartList);
};
